import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpService } from '../../../core/services/http.service';
import { AuthService } from '../../../core/services/auth/auth.service';
import { environment } from '../../../../environments/environment';

const HEADERS = {};

@Injectable()
export class NotificationsService {

  static ENV = environment;

  subjectNotify = new Subject();

  constructor(
    private httpProvider: HttpService,
    private authService: AuthService
  ) {
    HEADERS['Content-Type'] = 'application/json';
  }

  getNotifications() {
    this.authService.getSession().then(
      (user: any) => {
        let username = user.username;
        let urlBack = NotificationsService.ENV.environment.NOTIFICATIONS;
       

        if (urlBack) {
          let url = urlBack.usernotifications;
          this.httpProvider.get(`${url}?username=${username}`, {
            success: (resp) => {
              this.subjectNotify.next(resp.data);
            },
            error: (e) => {
              console.log('Error => ', e);
            },
            headers: HEADERS,
            includeToken : true
          });

        }

      }
    );

  }

  markAsRead(id_notification) {

    let url = NotificationsService.ENV.environment.NOTIFICATIONS.usernotifications;

    this.httpProvider.put(`${url}/${id_notification}`, {},
      {
        success: (resp) => {
          this.getNotifications();
        },
        error: (e) => {
          console.log('Error => ', e);
        },
        headers: HEADERS
      }
    );

  }

  getObserver() {
    return this.subjectNotify.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/profile/notifications.service.ts